module.exports = __webpack_public_path__ + "img/pin-nexus.944326e9.png";